import { useEvent } from '@emerald-works/react-event-bus-client'
import { Hub } from '@aws-amplify/core'
import React, { useCallback, useEffect, useState } from 'react'
import { useSession } from '@emerald-works/react-auth'
import { getUserPrimaryIdentity } from '../helpers/checkForUserIdentities'

/**
 * Listen to Amplify auth events and trigger events or other actions
 * depending on their success/faliure
 */
const useAuthEvents = () => {
  const [authEvents, setAuthEvents] = useState([])
  const [loginSucceed, loginFailed] = useEvent([{ eventName: 'userLoginSucceeded' }, { eventName: 'userLoginFailed' }])
  const { isAuthenticated, user } = useSession()

  const updateAuthEvents = useCallback((payload) => setAuthEvents(state => [...state, payload]), [])

  React.useEffect(() => {
    const eventListener = Hub.listen('auth', ({ payload }) => {
      updateAuthEvents(payload)
    })
    return eventListener
  }, [updateAuthEvents])

  useEffect(() => {
    if (!authEvents.length) return

    setAuthEvents(state => state.filter(item => {
      switch (item.event) {
        case 'signIn':
          if (isAuthenticated) {
            let identity = getUserPrimaryIdentity(user)
            if (!identity) {
              identity = { providerType: 'username_password' }
            }
            loginSucceed.trigger({ identity })
            return false
          }
          return true
        case 'signOut':
          return false
        case 'signIn_failure': {
          const { data } = item
          loginFailed.trigger({ reason: data?.message, code: data?.code })
          return false
        }
        default:
          return false
      }
    }))
  }, [authEvents.length, setAuthEvents, isAuthenticated, loginSucceed, loginFailed, user])
}

export default useAuthEvents
